import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminRateTypesScreen from "../../../container/RateAdminScreen/RateAdminRateTypesScreen";
import CreateRateAdminRateTypes from "../../../container/RateAdminScreen/RateAdminRateTypesScreen/CreateRateAdminRateTypes";

const RateAdminRateTypesRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_TYPES.HOME}
          element={
            <RateAdminRateTypesScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_TYPES.CREATE}
          element={<CreateRateAdminRateTypes />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_TYPES.EDIT}
          element={<CreateRateAdminRateTypes isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminRateTypesRoutes;
